import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ModuleLinkPipe } from "./module-link.pipe";

@NgModule({
  imports: [
      CommonModule
  ],
  declarations: [
      ModuleLinkPipe
  ],
  exports: [
    ModuleLinkPipe
  ]
})
export class PipeModule { }
